import React from 'react'
import Nav from '../Nav'
import ServicesHero from './ServicesHero'
import Footer from '../Footer'
import AboutSection from './AboutSection'
import Reviews from '../Home/Reviews'
import ContactSection from './ContactSection'
import WorkplaceSection from './WorkplaceSection'

const Service3 = () => {
    return (
        <>
            <Nav />
            <ServicesHero />
            <WorkplaceSection />
            <AboutSection />
            <Reviews />
            <ContactSection />
            <Footer />
        </>
    )
}

export default Service3